/**
 * city/buildings/tube-houses.js
Dựng các loại nhà phố ống & biệt thự đô thị Việt Nam
 */

import { registerTubeHouseClassicMethods } from './tube-house-classic.js';
import { registerTubeHouseShopsMethods } from './tube-house-shops.js';
import { registerVillaMethods } from './villa.js';

class MethodsHolder {
  // Điều phối tạo nhà phố đa dạng
  createTubeHouse(options = {}) {
    const style = options.style || 'classic';
    if (style === 'modern') return this.createTubeHouseModern(options);
    if (style === 'commercial') return this.createTubeHouseCommercial(options);
    if (style === 'cafe') return this.createTubeHouseCafe(options);
    return this.createTubeHouseClassic(options);
  }
}

export function registerTubeHouseMethods(proto) {
  registerTubeHouseClassicMethods(proto);
  registerTubeHouseShopsMethods(proto);
  registerVillaMethods(proto);

  Object.getOwnPropertyNames(MethodsHolder.prototype).forEach((name) => {
    if (name !== 'constructor') {
      proto[name] = MethodsHolder.prototype[name];
    }
  });
}
